import React, { useContext, useEffect, useState } from 'react';
import styles from './styles.scoped.css';
import Button from '../../components/elements/Button/Button';
import ButtonFileInput from '../../components/elements/ButtonFileInput/ButtonFileInput';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { AppContext } from '../../contexts';
import Card from '../../components/elements/Card';
import { useNavigate } from 'react-router-dom';
import {
  activateMyptmFileActivation,
  getExportedFormatMyptmActivation,
} from './actions';
import { getUserIdMyptmActivation } from '../../utils/storage';

export function BulkActivation({ change }) {
  const { setBreadcrumbs } = useContext(AppContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    activation: { success, loading, message },
  } = useSelector((state) => state.myptmActivation);
  const { values } = useSelector((state) => state.form.bulkMyptmActivation);
  const [error, setError] = useState({});
  const [file, setFile] = useState({});

  const clearErrors = () => {
    setError({});
  };

  let bodyFormData = new FormData();

  const handleRemoveFormData = () => {
    setFile({});
  };

  const handleChangeFile = (name, val) => {
    const modPayload = { file: val };
    Object.keys(modPayload).forEach((val) => {
      bodyFormData.append(name, modPayload[val]);
    });
    setFile(bodyFormData);
  };

  const handleIsValid = () => {
    if (
      file instanceof FormData &&
      Object.keys(error).length === 0 &&
      loading !== true
    ) {
      return false;
    }
    return true;
  };

  const handleDownload = () => {
    const userId = getUserIdMyptmActivation()?.userId;
    dispatch(getExportedFormatMyptmActivation(userId));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(activateMyptmFileActivation(values.file));
  };

  useEffect(() => {
    change('file', file);
  }, [file]);

  useEffect(() => {
    if (message?.includes(' is required') && !success) {
      setError({ file: { message: 'Belum memasukkan file' } });
    }
  }, [success, message]);

  useEffect(() => {
    setBreadcrumbs(['Aktivasi MyPertamina']);
  }, []);

  useEffect(() => {
    let reload = null;
    if (success) {
      reload = setTimeout(() => navigate(-1), 3000);
    }
    return () => clearTimeout(reload);
  }, [success]);

  return (
    <div className={styles.bulk}>
      <form
        className={styles.form__bulk}
        encType="multipart/form-data"
        onSubmit={handleSubmit}
      >
        <Card>
          <img
            className={styles['illustration-upload']}
            src="assets/illu-registrasi-pangkalan.svg"
          />
          <h4>
            Pilih file dengan format .xlsx untuk aktivasi pembayaran MyPertamina
            dalam jumlah banyak
          </h4>
          <ButtonFileInput
            clearErrors={clearErrors}
            deleteFile={handleRemoveFormData}
            errors={error.file}
            extensionAllowed={['xlsx']}
            handleChangeFile={handleChangeFile}
            name="file"
            noBase64={true}
            outlined={true}
            setError={setError}
            sizeValidation={{ kbsize: 3000000 }}
          >
            Unggah File
          </ButtonFileInput>
        </Card>
        <Card>
          <h5>Cara Tambah Sekaligus:</h5>
          <ul>
            <li>
              Unduh file Excel{' '}
              <button
                className={styles.button__text}
                onClick={handleDownload}
                type="button"
              >
                di sini
              </button>
            </li>
            <li>Isi MID LinkAja Pangkalan LPG 3 kg dengan benar.</li>
            <li>
              Unggah kembali file yang sudah diisi ke halaman ini dengan menekan
              tombol Unggah File.
            </li>
          </ul>
        </Card>
        <div className={styles.form__actions}>
          <Button onClick={() => navigate(-1)} style="danger" type="button">
            Batal
          </Button>
          <Button disabled={handleIsValid()} type="submit">
            Simpan
          </Button>
        </div>
      </form>
    </div>
  );
}

BulkActivation.propTypes = {
  change: PropTypes.func,
  handleSubmit: PropTypes.func,
};

export default reduxForm({
  form: 'bulkMyptmActivation',
  initialValues: {
    file: [],
  },
})(BulkActivation);
